Specials =
{
	init : function()
	{
		// Make bucket showcases the same height.
		jQuery('.specials-list .content').matchHeight({
		    byRow: true,
		    property: 'height',
		    target: null,
		    remove: false
		});
	}
};//end object literal Specials
			
jQuery(document).ready(function(jQuery){

	Specials.init();

});
